<template>
  <div>
    <tw-header :title="$t('BreadCrumbs.Import Customs Clearance List')"></tw-header>
    <div class="tw_container">
      <tw-breadcrumbs :pages="breadcrumbs" style="margin-bottom: 40px" />
      <!-- <tw-entity-buttons /> -->

      <el-form class="search_unit compact" ref="searchUnit" :model="searchForm" label-position="top">
        <div class="row">
          <el-form-item class="max-content" :label="$t('Label.Update Datetime')" prop="processUpdateDateTime">
            <el-date-picker
              v-model="searchForm.processUpdateDateTime"
              type="datetimerange"
              range-separator="to"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="Start datetime"
              end-placeholder="End datetime">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Trading Name')" prop="tradingName">
            <el-input type="text" v-model="searchForm.tradingName" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Flow Name')" prop="flowName">
            <el-input type="text" v-model="searchForm.flowName" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Process')" prop="processTypes">
            <el-select v-model="searchForm.processTypes" :class="{multiple_selected: multipleSelect(searchForm.processTypes)}" placeholder="Select" multiple collapse-tags clearable>
              <el-option
                v-for="process in processes"
                :key="process.name"
                :label="process.name"
                :value="process.processType"
              >
                <span>{{process.name}}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Process User Memo')" prop="processUserMemo">
            <el-input type="text" v-model="searchForm.processUserMemo" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-badge :value="searchConditionNum" :hidden="searchConditionNum === 0">
            <tw-button
              type="secondary"
              size="medium"
              @click="isOpenSearchDialog = true"
            >
              Advanced Search
            </tw-button>
          </el-badge>
        </div>

        <div class="row drop space_between">
          <div>
            <tw-button
              type="secondary"
              size="medium"
              icon="search"
              @click="search"
            >
              Search
            </tw-button>
            <tw-button
              type="default"
              size="medium"
              @click="clear"
              style="margin: 8px 16px 16px;"
            >
              Clear
            </tw-button>
          </div>

          <div>
            <el-dropdown trigger="click" placement="bottom" @command="onDropDownClick" :tabindex="-1">
              <tw-button class="menu_button" type="secondary" size="small" icon="menu">{{ $t('Label.View Options') }}</tw-button>
              <el-dropdown-menu class="nowrap">
                <el-dropdown-item command="openTableSettingDialog">{{ $t('Label.Column Preference') }}</el-dropdown-item>
                <el-dropdown-item command="changeTableWidth">{{ tableMode === 'show' ? $t('Label.Column Width') : $t('Label.Complete Width Edit Mode') }}</el-dropdown-item>
                <el-dropdown-item command="resetTableSetting">{{ $t('Label.Reset Column') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <tw-button
              type="secondary"
              size="small"
              style="margin-left: 10px"
              @click="tsvDownLoadClick"
            >
              {{ $t('Label.TSV Download') }}
            </tw-button>
          </div>
        </div>
      </el-form>

      <tw-table-system :schemas="showSchema" :items="items" :border="tableMode === 'changeWidth'" :pageSize="limit" :totalCount="totalCount" :offset="offset" :selection="selection" :serverPagination="true" @row-click="rowClick" @row-dbclick="rowDbClick" @paging="onPaging" @change-column-width="changeColumnWidth" />
    </div>
    <tw-table-column-setting-dialog
      :visible.sync="isOpenTableSettingDialog"
      :full-schemas="schemas"
      :show-schemas.sync="filteredSchemas"
      @close="updateColumnSetting"
    ></tw-table-column-setting-dialog>
    <el-dialog
      class="search-condition-dialog"
      :visible.sync="isOpenSearchDialog"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form
        class="search_unit compact"
        v-loading="isSearching"
        ref="searchUnit"
        :model="searchForm"
        label-position="top"
      >
        <div class="row" style="border-bottom: 1px solid #BFBFCD;margin-bottom: 12px;">
          <el-form-item class="max-content" :label="$t('Label.Update Datetime')" prop="processUpdateDateTime">
            <el-date-picker
              v-model="searchForm.processUpdateDateTime"
              type="datetimerange"
              range-separator="to"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="Start datetime"
              end-placeholder="End datetime">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Trading Name')" prop="tradingName">
            <el-input type="text" v-model="searchForm.tradingName" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Flow Name')" prop="flowName">
            <el-input type="text" v-model="searchForm.flowName" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Process')" prop="processTypes">
            <el-select v-model="searchForm.processTypes" :class="{multiple_selected: multipleSelect(searchForm.processTypes)}" placeholder="Select" multiple collapse-tags clearable>
              <el-option
                v-for="process in processes"
                :key="process.name"
                :label="process.name"
                :value="process.processType"
              >
                <span>{{process.name}}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Process User Memo')" prop="processUserMemo">
            <el-input type="text" v-model="searchForm.processUserMemo" placeholder="Enter keyword"></el-input>
          </el-form-item>
        </div>
        <div class="row" style="border-bottom: 1px solid #BFBFCD;margin-bottom: 12px;">
          <el-form-item :label="$t('Label.Status')" prop="status">
            <el-select v-model="searchForm.status" :class="{multiple_selected: multipleSelect(searchForm.status)}" placeholder="Select" multiple collapse-tags clearable>
              <el-option
                v-for="status in PROCESS_PROGRESS_STATUS_VARIABLES"
                :key="status.code"
                :label="status.label"
                :value="status.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Im Custom Invoice No')" prop="imCustomInvoiceNo">
            <el-input type="text" v-model="searchForm.imCustomInvoiceNo" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.I/I No')" prop="siNo">
            <el-input type="text" v-model="searchForm.siNo" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Trading/Flow ID')" prop="tradingFlowId">
            <el-input type="text" v-model.trim="searchForm.tradingFlowId" placeholder="Enter keyword" class="trading-flow"></el-input>
          </el-form-item>
          <el-form-item class="max-content" :label="$t('Label.Create Datetime')" prop="processCreateDateTime">
            <el-date-picker
              v-model="searchForm.processCreateDateTime"
              type="datetimerange"
              range-separator="to"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="Start datetime"
              end-placeholder="End datetime">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Section(From)')" prop="fromSectionIds">
            <TwSelectSection v-model="searchForm.fromSectionIds" :sections="fromSections" />
          </el-form-item>
          <el-form-item :label="$t('Label.Section(To)')" prop="toSectionIds">
            <TwSelectSection v-model="searchForm.toSectionIds" :sections="toSections" />
          </el-form-item>
          <el-form-item :label="$t('Label.Im Reference (From)')" prop="imFromReference">
            <el-input type="text" v-model="searchForm.imFromReference" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Im Reference (To)')" prop="imToReference">
            <el-input type="text" v-model="searchForm.imToReference" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Im PIC (From)')" prop="imFromPIC">
            <el-input type="text" v-model="searchForm.imFromPIC" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Im PIC (To)')" prop="imToPIC">
            <el-input type="text" v-model="searchForm.imToPIC" placeholder="Enter keyword"></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item :label="$t('Label.P/O No')" prop="poNo">
            <el-input type="text" v-model="searchForm.poNo" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Contract No')" prop="contractNo">
            <el-input type="text" v-model="searchForm.contractNo" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Main Goods')" prop="goodsName">
            <el-input type="text" v-model="searchForm.contractGroupOfGoods" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Seller')" prop="sellerName">
            <el-input type="text" v-model="searchForm.sellerName" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.End User')" prop="endUser">
            <el-input type="text" v-model="searchForm.endUserName" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Vessel Name')" prop="vesselName">
            <el-input type="text" v-model="searchForm.nameOfVessel" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.B/L No')" prop="blNo">
            <el-input type="text" v-model="searchForm.blNo" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Booking No')" prop="vesselBookingNo">
            <el-input type="text" v-model="searchForm.vesselBookingNo" placeholder="Enter keyword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Label.Transportation')" prop="transportation">
            <el-select v-model="searchForm.transportation" placeholder="Select" collapse-tags clearable>
              <el-option
                v-for="status in TRANSPORTATION_VARIABLES"
                :key="status.code"
                :label="status.label"
                :value="status.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Type Of Service From')" prop="typeOfServiceFrom">
            <el-select v-model="searchForm.typeOfServiceFrom" placeholder="Select" collapse-tags clearable>
              <el-option
                v-for="status in TYPE_OF_SERVICE_FCL_LCL_VARIABLES"
                :key="status.code"
                :label="status.label"
                :value="status.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Hazardous')" prop="hazardousFlag">
            <el-select v-model="searchForm.hazardousFlag" placeholder="Select" collapse-tags clearable>
              <el-option
                v-for="mode in HAZARDOUS_FLAG_VARIABLES"
                :key="mode.code"
                :label="mode.label"
                :value="mode.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Port of Discharge')" prop="portOfDischargingName">
              <el-input type="text" v-model="searchForm.portOfDischargingName" placeholder="Enter keyword"></el-input>
            </el-form-item>
          <el-form-item :label="$t('Label.ETA')" prop="dischargingEta">
            <el-date-picker
              v-model="searchForm.dischargingEta"
              type="daterange"
              range-separator="to"
              format="yyyy-MM-dd"
              :default-value="defaultDate"
              @change.native="onDateRangeChange"
              start-placeholder="Start date"
              end-placeholder="End date">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Discharging Current ETA')" prop="dischargingCurrentEta">
            <el-date-picker v-model="searchForm.dischargingCurrentEta" type="daterange" range-separator="to" format="yyyy-MM-dd" :default-value="defaultDate" @change.native="onDateRangeChange" start-placeholder="Start date" end-placeholder="End date"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Discharging ATA')" prop="dischargingATA">
            <el-date-picker v-model="searchForm.dischargingAta" type="daterange" range-separator="to" format="yyyy-MM-dd" :default-value="defaultDate" @change.native="onDateRangeChange" start-placeholder="Start date" end-placeholder="End date"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Im Request Declaration Date')" prop="imRequestDeclarationDate">
            <el-date-picker v-model="searchForm.imRequestDeclarationDate" type="daterange" range-separator="to" format="yyyy-MM-dd" :default-value="defaultDate" @change.native="onDateRangeChange" start-placeholder="Start date" end-placeholder="End date"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Scheduled Delivery Date')" prop="scheduledDeliveryDate">
            <el-date-picker v-model="searchForm.scheduledDeliveryDate" type="daterange" range-separator="to" format="yyyy-MM-dd" :default-value="defaultDate" @change.native="onDateRangeChange" start-placeholder="Start date" end-placeholder="End date"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Delivery Date')" prop="deliveryDate">
            <el-date-picker v-model="searchForm.deliveryDate" type="daterange" range-separator="to" format="yyyy-MM-dd" :default-value="defaultDate" @change.native="onDateRangeChange" start-placeholder="Start date" end-placeholder="End date"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Scheduled Devanning Date')" prop="scheduledDevanningDate">
            <el-date-picker v-model="searchForm.scheduledDevanningDate" type="daterange" range-separator="to" format="yyyy-MM-dd" :default-value="defaultDate" @change.native="onDateRangeChange" start-placeholder="Start date" end-placeholder="End date"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('Label.Cargo Tracking')" prop="imCargoTrackingFlg">
            <el-select v-model="searchForm.imCargoTrackingFlg" placeholder="Select" collapse-tags clearable>
              <el-option
                v-for="status in CARGO_TRACKING_FLG_VARIABLES"
                :key="status.code"
                :label="status.label"
                :value="status.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Attach File')" prop="documentLink">
            <el-cascader 
              v-model="searchForm.documentLink" 
              :options="documentLinkOptions" 
              :props="{ expandTrigger: 'click'}" 
              placeholder="Select" 
              @change="handleFileSelection" 
              clearable>
            </el-cascader>
          </el-form-item>
          <el-form-item :label="$t('Label.CO Required')" prop="coRequiredFlag">
            <el-select v-model="searchForm.coRequiredFlag" placeholder="Select" collapse-tags clearable>
              <el-option
                v-for="status in CO_REQUIRED_FLAG_VARIABLES"
                :key="status.code"
                :label="status.label"
                :value="status.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Other Laws And Regulations')" prop="isAnyRegulationChecked">
            <el-select v-model="searchForm.isAnyRegulationChecked" placeholder="Select" collapse-tags clearable>
              <el-option
                v-for="status in REGULATION_FLAG_VARIABLES"
                :key="status.code"
                :label="status.label"
                :value="status.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Im New Items')" prop="imNewGoodsFlag">
            <el-select v-model="searchForm.imNewGoodsFlag" placeholder="Select" collapse-tags clearable>
              <el-option
                v-for="status in NEW_GOODS_FLAG_VARIABLES"
                :key="status.code"
                :label="status.label"
                :value="status.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Linking Status')" prop="permitLinkFlg">
            <el-select v-model="searchForm.permitLinkFlg" placeholder="Select" collapse-tags clearable>
              <el-option
                v-for="status in PERMIT_LINK_FLG_VARIABLES"
                :key="status.code"
                :label="status.label"
                :value="status.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Label.Amendment')" prop="amendmentFlg" style="margin-right: 12px">
            <el-select v-model="searchForm.amendmentFlg" placeholder="Select" collapse-tags clearable>
              <el-option
                v-for="status in AMENDMENT_FLG_VARIABLES"
                :key="status.code"
                :label="status.label"
                :value="status.code">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          
        </div>
      </el-form>
      <div slot="footer" class="row drop space_between">
        <div>
          <tw-button
            type="secondary"
            size="medium"
            icon="search"
            @click="search"
          >
            Search
          </tw-button>
          <tw-button
            type="default"
            size="medium"
            @click="clear"
            style="margin: 8px 16px 16px;"
          >
            Clear
          </tw-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import { IMPORT_CUSTOMS_SEARCH_SORT_TARGET, ENTITY_TYPE, PERMIT_LINK_FLG_VARIABLES, AMENDMENT_FLG_VARIABLES, CARGO_TRACKING_FLG_VARIABLES, DOCUMENT_LINK_VARIABLES, ATTACHED_FILE_FLG, TRANSPORTATION_VARIABLES, TYPE_OF_SERVICE_FCL_LCL_VARIABLES, HAZARDOUS_FLAG_VARIABLES, CO_REQUIRED_FLAG_VARIABLES, REGULATION_FLAG_VARIABLES, NEW_GOODS_FLAG_VARIABLES } from 'lib-tw-common';
import { $api } from '@/store/ApiClient';
import mixinEntityList from '@/utils/mixinEntityList.js';
import mixinEntity from '@/utils/mixinEntity.js';
import mixinTableSetting from '@/utils/mixinTableSetting.js';
import { collapseTransition } from '@/utils/nextFrame';
import { clearSearchForm, formatUtcDate } from '@/utils/searchUtil.js';
import schemas from '@/dictionaries/listImCustomsClearanceSchema.json';
import TwTableColumnSettingDialog from '@/components/organisms/TwTableColumnSettingDialog.vue';
import { tsvDownLoad } from '@/utils/listToTsvUtils.js';

const ENTITY_NAME = 'IM_CUSTOMS'

export default {
  name: 'ListImCustoms',
  mixins: [mixinEntityList, collapseTransition, mixinEntity, mixinTableSetting],
  components: {
    TwTableColumnSettingDialog
  },
  data() {
    return {
      entityCode: ENTITY_TYPE.IM_CUSTOMS,
      schemas: schemas,
      items: null,
      searchForm: {
        tradingFlowId: '',
        tradingName: '',
        flowName: '',
        imCustomInvoiceNo: '',
        siNo: '',
        fromSectionIds: [],
        toSectionIds: [],
        portOfDischargingName: '',
        dischargingEta: '',
        dischargingCurrentEta: '',
        dischargingAta: '',
        deliveryDate: '',
        contractGroupOfGoods: '',
        nameOfVessel: '',
        endUserName: '',
        status: [],
        permitLinkFlg: null,
        amendmentFlg: null,
        imCargoTrackingFlg: null,
        documentLink: [],
        processTypes: [],
        processUserMemo: "",
        processUpdateDateTime: [],
        processCreateDateTime: [],
        imFromReference: '',
        imToReference: '',
        imFromPIC: '',
        imToPIC: '',
        poNo: '',
        blNo: '',
        contractNo: '',
        sellerName: '',
        vesselBookingNo: '',
        transportation: null,
        typeOfServiceFrom: null,
        hazardousFlag: null,
        imRequestDeclarationDate: '',
        scheduledDeliveryDate: '',
        scheduledDevanningDate: '',
        coRequiredFlag: null,
        isAnyRegulationChecked: null,
        imNewGoodsFlag: null
      },
      limit: 50,
      offset: 0,
      sort: null,
      count: 0,
      totalCount: 0,
      pageCount: 0,
      lastQuery: {},
      PERMIT_LINK_FLG_VARIABLES,
      AMENDMENT_FLG_VARIABLES,
      CARGO_TRACKING_FLG_VARIABLES,
      DOCUMENT_LINK_VARIABLES,
      TRANSPORTATION_VARIABLES,
      TYPE_OF_SERVICE_FCL_LCL_VARIABLES,
      HAZARDOUS_FLAG_VARIABLES,
      CO_REQUIRED_FLAG_VARIABLES,
      REGULATION_FLAG_VARIABLES,
      NEW_GOODS_FLAG_VARIABLES,
      isOpenTableSettingDialog: false,
      tableId: 'listImCustomsClearance',
      isSearching: false,
      isOpenSearchDialog: false
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {label: this.$t('BreadCrumbs.Dashboard'), to: '/'},
        {label: this.$t('BreadCrumbs.Import Customs Clearance List')},
      ];
    },
    documentLinkOptions() {
      return DOCUMENT_LINK_VARIABLES.map(item => ({
        value: item.code,
        label: item.label,
        children:[
          { value: ATTACHED_FILE_FLG.ON, label: 'Attached' },
          { value: ATTACHED_FILE_FLG.OFF, label: 'Not Attached' }
        ]
      }));
    },
    searchConditionNum() {
      return Object.values(this.searchForm).reduce((result, val) => {
        if((Array.isArray(val) && val.length) || 
          typeof val === 'string' && val ||
          typeof val === 'number' && val !== null  
        ) {
          ++result
        }
        return result
      }, 0)
    },
  },
  created() {
    const queries = this.$store.getters.getQueries(ENTITY_NAME);
    if (queries) {
      this.searchForm = {
        ...this.searchForm, ...queries, documentLink: queries.documentLink || []
      };
    }
    this.fetch();
    this.processes = this.getProcessesByEntity(ENTITY_NAME);
  },
  methods: {
    // POSTパラメータを生成します
    transformQueries() {
      const f = this.searchForm;
      const queries = {
        fromSectionIds: f.fromSectionIds,
        toSectionIds: f.toSectionIds,
        etaStartDate: this.getYMDStartDate(f.dischargingEta),
        etaEndDate: this.getYMDEndDate(f.dischargingEta),
        dischargingCurrentEtaFrom: this.getYMDStartDate(f.dischargingCurrentEta),
        dischargingCurrentEtaTo: this.getYMDEndDate(f.dischargingCurrentEta),
        dischargingAtaFrom: this.getYMDStartDate(f.dischargingAta),
        dischargingAtaTo: this.getYMDEndDate(f.dischargingAta),
        deliveryDateFrom: this.getYMDStartDate(f.deliveryDate),
        deliveryDateTo: this.getYMDEndDate(f.deliveryDate),
        imRequestDeclarationDateFrom: this.getYMDStartDate(f.imRequestDeclarationDate),
        imRequestDeclarationDateTo: this.getYMDEndDate(f.imRequestDeclarationDate),
        scheduledDeliveryDateFrom: this.getYMDStartDate(f.scheduledDeliveryDate),
        scheduledDeliveryDateTo: this.getYMDEndDate(f.scheduledDeliveryDate),
        scheduledDevanningDateFrom: this.getYMDStartDate(f.scheduledDevanningDate),
        scheduledDevanningDateTo: this.getYMDEndDate(f.scheduledDevanningDate),
        tradingId: this.getTradingFlowId(f.tradingFlowId)[0],
        tradingFlowId: this.getTradingFlowId(f.tradingFlowId)[1],
        tradingName: f.tradingName,
        flowName: f.flowName,
        invoiceNo: f.imCustomInvoiceNo,
        siNo: f.siNo,
        // poNo: f.contractNo,
        goodsName: f.contractGroupOfGoods,
        vesselName: f.nameOfVessel,
        portOfDischargingName: f.portOfDischargingName,
        endUser: f.endUserName,
        processProgressStatus: this.getProcessProgressStatus(f.status),
        imFromReference: f.imFromReference,
        imToReference: f.imToReference,
        imFromPIC: f.imFromPIC,
        imToPIC: f.imToPIC,
        poNo: f.poNo,
        blNo: f.blNo,
        contractNo: f.contractNo,
        sellerName: f.sellerName,
        vesselBookingNo: f.vesselBookingNo,
        transportation: f.transportation,
        typeOfServiceFrom: f.typeOfServiceFrom,
        hazardousFlag: f.hazardousFlag,
        coRequiredFlag: f.coRequiredFlag,
        isAnyRegulationChecked: f.isAnyRegulationChecked,
        imNewGoodsFlag: f.imNewGoodsFlag,
        permitLinkFlg: f.permitLinkFlg,
        amendmentFlg: f.amendmentFlg,
        imCargoTrackingFlg: f.imCargoTrackingFlg,
        documentLinkType: f.documentLink.length > 0 ? f.documentLink[0] : null,
        documentLinkFlg: f.documentLink.length > 1 ? f.documentLink[1] : null,
        processIds: f.processTypes ? _.flatten(_.map(f.processTypes, item => this.getProcessIdsByProcessType(item))) : [],
        processUserMemo: f.processUserMemo,
        processUpdateDateTimeFrom: f.processUpdateDateTime ? formatUtcDate(f.processUpdateDateTime[0]) : null,
        processUpdateDateTimeTo: f.processUpdateDateTime?.[1] ? formatUtcDate(f.processUpdateDateTime[1]).replace('00Z', '59Z') : null,
        processCreateDateTimeFrom: f.processCreateDateTime ? formatUtcDate(f.processCreateDateTime[0]) : null,
        processCreateDateTimeTo: f.processCreateDateTime?.[1] ? formatUtcDate(f.processCreateDateTime[1]).replace('00Z', '59Z') : null,
      };

      return {
        ...queries,
        initialFlag: this.initialFlag(queries),
        limit: this.limit,
        offset: this.offset,
        sort: this.sort,
      };
    },
    fetch(queries) {
      this.cancelRequestSources.forEach(tag => {
        $api.cancelRequests(tag);
      });
      // bff_ic_1 輸入通関一覧検索BFF
      const params = {
        lslConfig: {
          serviceCode: 'tw-transaction-bff-api',
          apiCode: 'get_/v1/import-customs/search',
          query: queries || this.transformQueries()
        },
        tag: this.pushCancelTag(),
      };

      this.lastQuery = _.cloneDeep(params.lslConfig.query);

      return $api.request(params)
      .then(res => {
        this.items = res.importCustoms;
        this.totalCount = res.totalCount;
        return { isError: false };
      })
      .catch(err => {
        if (err.isCanceled) {
          return;
        }
        this.items = [];
        this.$store.dispatch('SHOW_ALERT', err.message);
        return { isError: true };
      });
    },
    async search() {
      this.isSearching = true;
      this.offset = 0;
      this.$store.commit('SET_QUERIES', {key: ENTITY_NAME, queries: _.cloneDeep(this.searchForm)});
      const { isError } = await this.fetch();
      this.isSearching = false;
      if (!isError) this.isOpenSearchDialog = false;
    },
    clear() {
      this.searchForm = clearSearchForm(this.searchForm);
      this.$store.commit('SET_QUERIES', {key: ENTITY_NAME, queries: _.cloneDeep(this.searchForm)});
    },
    onPaging({target, sortType, currentPage}) {
      if (target && sortType) {
        const key = _.get(_.find(this.schemas, {key: target}), 'sortTarget');
        this.sort = {
          target: [IMPORT_CUSTOMS_SEARCH_SORT_TARGET[key] || target],
          sortType: [sortType],
        };
      } else {
        this.sort = null;
      }

      this.offset = currentPage * this.limit - this.limit;
      const queries = {
        ...this.lastQuery,
        limit: this.limit,
        offset: this.offset,
        sort: this.sort,
      };
      this.fetch(queries);
    },
    // TSVダウンロード用に全件取得します
    fetchAll() {
      return new Promise((resolve, reject) => {
        // bff_ic_1 輸入通関一覧検索BFF
        const params = {
          lslConfig: {
            serviceCode: 'tw-transaction-bff-api',
            apiCode: 'get_/v1/import-customs/search',
            query: { ...this.transformQueries(), offset: undefined, limit: undefined }
          }
        };

        $api.request(params)
        .then(res => {
          resolve(res.importCustoms);
        })
        .catch(err => {
          this.$store.dispatch('SHOW_ALERT', err.message);
          reject();
        });
      });
    },
    //カスケーダ処理
    handleFileSelection(value) {
      if (Array.isArray(value) && value.length > 0){
        this.searchForm.documentLink[0] = value[0];
        this.searchForm.documentLink[1] = value[1];
      } else {
        this.searchForm.documentLink = [];
      }
    },
    async tsvDownLoadClick(){
      const items = await this.fetchAll();
      tsvDownLoad(this.schemas, items);
    },
  }
};
</script>

<style lang="scss" scoped>
.search_unit {
  & .row {
    align-items: center;
  }
  & .el-form-item {
    margin-bottom: 24px
  }
  & .max-content {
    width: max-content;
  }
}
::v-deep .tw_table {
  background-color: #d6d6dc;
  &.el-table--border th, &.el-table--border td {
    border-right: 1px solid #BFBFCD;
  }
  & .el-table__body, & .el-table__header {     
    min-width: unset !important;
    & .gutter {
      border: none;
      background-color: #d6d6dc;
    }
  }
}
.tw_container {
  background: $color_white;
}
</style>
<style lang="scss">
.search-condition-dialog {
  & .el-dialog {
    display: flex;
    flex-direction: column;
    width: 70vw;
    height: 80vh;

    & .el-dialog__body {
      padding-bottom: 0;
      max-height: calc(100% - 100px);
      overflow: auto;
      & .row{
        &.detailed-conditions {
          border-top: 1px solid #BFBFCD;
          padding-top: 8px;
        }
      }
      & .el-select {
        width: 100%;
        & input {
          width: 100%;
        }
      }
      & .el-date-editor:has(input:not(:placeholder-shown)),
      & .el-input__inner:not(.el-date-editor):not(:placeholder-shown),
      & .el-select:has(.el-tag) .el-input .el-input__inner {
        background-color: rgba(#b2efcb, .3);
      }
    }

    & .el-dialog__footer {
      height: 100px;
    }
  }
}
</style>
